<template>
  <div class="woo-playlist-wrapper">
    <div class="woo-playlist" ref="wooPlaylist">
      <video-player
        v-for="(video, $index) in videos"
        :onClose="closeVideo"
        :options="getVideoOptions(video)"
        :event="video.event"
        :title="video.display_name"
        :manualLoop="false"
        :showRepeatBar="true"
        :key="video.id"
        :ref="`video_${$index}`"
        :verticalSwipe="true"
        :class="{
          active: isVideoActive(video),
        }"
        :video="video"
        :hidePrevButton="hidePrevButton"
      >
        <v-row class="woo-playlist-navigation" :class="{ active: activeVideo }">
          <v-col v-for="(video, $index) in videos" :key="video.id">
            <div class="microstep"></div>
            <span v-if="isLoaded">
              <div
                class="completed"
                :style="{
                  width: getProgressForVideo($index),
                }"
              ></div>
            </span>
          </v-col>
        </v-row>
      </video-player>
      <!-- <transition
        enter-active-class="animate__animated animate__slideInLeft animate__faster"
        leave-active-class="animate__animated animate__slideOutRight animate__faster"
        mode="out-in">
        <div class="woo-video-transition" v-if="transition">
          <div class="woo-video-transition-header">Next Up</div>
          <div
            class="woo-video-transition-inner animate__animated animate__bounceIn">{{transition}}</div>
        </div>
      </transition> -->
    </div>
      
  </div>
</template>
<script>
import VideoPlayer from './VideoPlayer.vue';
import hub, { Events } from '../helpers/EventHub';
import Db from '@/helpers/Db';
import HelperMethods from '@/helpers/HelperMethods';
import { LINKS } from '@/constants';

export default {
  components: { VideoPlayer },
  name: 'VideoPlaylist',
  data() {
    return {
      treshold: 100,
      videoResetTimeout: undefined,
      touchStartY: undefined,
      touchEndY: undefined,
      isLoaded: false,
      hidePrevButton: true,
      transition: false,
    };
  },
  computed: {
    activeVideo() {
      return this.$route.query.v || undefined;
    },
    activeStep() {
      return this.$route.query.s || undefined;
    },
    activeStepIndex() {
      return this.tutorial.sections.map(x => x.steps).flat().findIndex(
        step => step.id === this.activeStep
      );
    },
    activeVideoIndex() {
      if (this.activeVideo && this.videos) {
        return this.videos.findIndex(video => video.id == this.activeVideo);
      } else {
        return undefined;
      }
    },
    tutorial() {
      return Db.getFullTutorialBySlug(this.$route.params.id);
    },
    videos() {
      if (!this.$route.query.s) return

      this.triggerPlayVideo();

      const step = Db.findStepById({
        tutorial: this.tutorial,
        stepId: this.$route.query.s,
      });

      return step?.microsteps;
    },
  },
  watch: {
    activeVideoIndex(newValue, oldValue) {
      if (oldValue >= 0 && newValue !== oldValue) {
        this.$refs[`video_${oldValue}`][0].player.pause();
        this.$refs[`video_${oldValue}`][0].player.currentTime(0);
      }
    },
    videos() {
      this.triggerPlayVideo();
    },
  },
  mounted() {
    if (
      !this.$refs.wooPlaylist ||
      (!this.videos && (this.activeStep || this.activeVideo)) ||
      this.activeVideoIndex < 0
    ) {
      this.$router.replace('/404');
    }
    
    hub.$on(Events.PlayNextVideo, this.playNextVideo);
    hub.$on(Events.PlayPreviousVideo, this.playPreviousVideo);
    hub.$on(Events.PlayVideo, this.playVideo);
    hub.$on(Events.PauseVideo, this.pauseVideo);
    hub.$on(Events.ReplayVideo, this.replayVideo);
    
    this.$refs.wooPlaylist.addEventListener('touchstart', (e) => {
      this.touchStartY = e.touches[0].clientY;
    });
    
    this.$refs.wooPlaylist.addEventListener('touchend', (e) => {
      this.touchEndY = e.changedTouches[0].clientY;
    });
    
    this.scrollToActiveVideo(true);
    
    const refInterval = setInterval(() => {
      if (this.$refs['video_0'] && this.$refs['video_0'].length > 0) {
        this.isLoaded = true;
        clearInterval(refInterval);
      }
    });
  },
  destroyed() {
    hub.$off(Events.PlayNextVideo, this.playNextVideo);
    hub.$off(Events.PlayPreviousVideo, this.playPreviousVideo);
    hub.$off(Events.PlayVideo, this.playVideo);
    hub.$off(Events.PauseVideo, this.pauseVideo);
    hub.$off(Events.ReplayVideo, this.replayVideo);
    this.isLoaded = false;
  },

  methods: {
    setVideoPreload(index) {
      const ref = this.$refs[`video_${index}`];
      if (!ref || !ref[0]) return;
      ref[0].player.preload('auto');
    },
    triggerPlayVideo() {
      this.isLoaded = false;
      
      const refInterval = setInterval(() => {
        if (this.$refs['video_0'] && this.$refs['video_0'].length > 0) {
          this.isLoaded = true;
          clearInterval(refInterval);
          this.hidePrevButton =
            this.activeStepIndex === 0 && this.activeVideoIndex === 0;
        }
      });

      setTimeout(() => {
        this.playVideo();
      }, 500);
    },
    isVideoActive(video) {
      return video.id === this.activeVideo;
    },
    getProgressForVideo(videoIndex) {
      if (this.isLoaded) {
        if (videoIndex === this.activeVideoIndex) {
          return `${this.$refs[`video_${videoIndex}`][0].currentTime}%`;
        } else if (videoIndex < this.activeVideoIndex) {
          return '100%';
        } else {
          return '0';
        }
      } else {
        return '0';
      }
    },
    replayVideo() {
      if (this.activeVideoIndex === this.videos.length - 1) {
        HelperMethods.setCompletedStep(this.$route.query.s)
      }
    },
    playNextVideo() {
      // Check if we have more videos to play
      if (this.activeVideoIndex < this.videos.length - 1) {
        this.$router.push({
          query: {
            v: this.videos[this.activeVideoIndex + 1].id,
            s: this.$route.query.s,
          },
        }).catch();
      } else {
        HelperMethods.setCompletedStep(this.$route.query.s)
        
        const nextStep = this.getNextStep();
        
        if (!nextStep) {
          // We don't have a next step, its the end of the tutorial
          window.location = this.tutorial.end_of_guide_url || LINKS.SHOPIFY_KITS;
          return;
        } else if (Db.isStepFirstInGroup({
          tutorial: this.tutorial,
          step: nextStep
        })) {
          // We have a next step, but its in the next section, show Summary
          this.$router.push({
            name: 'summary',
            params: {
              id: this.$route.params.id,
            },
            query: {
              g: this.currentStep().sectionId,
            },
          }).catch();
        } else {
          this.$router.push({
            query: {
              v: nextStep.microsteps[0].id,
              s: nextStep.id,
            },
          }).catch();

          // Show transition
          // this.pauseVideo();
          
          // this.transition = nextStep.display_name;

          // setTimeout(() => {
          //   this.transition = false;

          //   // Go to next step in current section
          //   this.$router.push({
          //     query: {
          //       v: nextStep.microsteps[0].id,
          //       s: nextStep.id,
          //     },
          //   });
          // }, 3500);
        }
      }
    },
    playPreviousVideo() {
      if (this.activeVideoIndex > 0) {
        this.$router.push({
          query: {
            v: this.videos[this.activeVideoIndex - 1].id,
            s: this.$route.query.s,
          },
        }).catch();
      } else {
        let previousStep = this.getPreviousStep();
        
        if (previousStep.id === this.$route.query.s) {
          this.$router.push({
            name: 'tutorial',
            params: {
              id: this.$route.params.id,
            },
          }).catch();
        } else {
          this.$router.push({
            query: {
              v: previousStep.microsteps[previousStep.microsteps.length - 1].id,
              s: previousStep.id,
            },
          }).catch();
        }
      }
    },
    getVideoOptions(microstep) {
      return HelperMethods.getVideoOptions({
        microstep,
        tutorialId: this.tutorial.id,
      });
    },
    playVideo() {
      // We should only play if we're not at the end of the video
      if (this.activeVideoIndex >= 0 && this.getProgressForVideo(this.activeVideoIndex) !== '100%') {
        this.$refs[`video_${this.activeVideoIndex}`][0].player.play()
        .catch(() => {
          // ignore - this is probably interrupted by pause()
          // or by navigating away but we don't care about it
        });
        this.setVideoPreload(this.activeVideoIndex + 1);
      }
    },
    pauseVideo() {
      if (this.activeVideoIndex >= 0)
        this.$refs[`video_${this.activeVideoIndex}`][0].player.pause();
    },
    closeVideo() {
      this.isLoaded = false;
      this.$router.push({
        name: 'tutorial',
        params: {
          id: this.$route.params.id,
        },
      }).catch();
    },
    showHelp() {
      hub.$emit(Events.ShowHelp);
    },
    currentStep() {
      return Db.findStepById({
        tutorial: this.tutorial,
        stepId: this.$route.query.s,
      })
    },
    getNextStep() {
      return Db.findStepWithOffsetFromId({
        tutorial: this.tutorial,
        stepId: this.$route.query.s,
        offset: 1
      });
    },
    getPreviousStep() {
      return Db.findStepWithOffsetFromId({
        tutorial: this.tutorial,
        stepId: this.$route.query.s,
        offset: -1
      });
    },
    scrollToActiveVideo(instant) {
      if (
        this.$refs[`video_${this.activeVideoIndex}`] &&
        this.$refs[`video_${this.activeVideoIndex}`][0]
      ) {
        let activeVideo = this.$refs[`video_${this.activeVideoIndex}`][0];
        this.$refs.wooPlaylist.scrollTo({
          top: activeVideo.$el.offsetTop,
          behavior: instant ? 'instant' : 'smooth',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.woo-playlist {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.woo-video-transition {
  background-color: teal;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%; 
  padding: 1rem;
  position: fixed;
  z-index: 100;

  .woo-video-transition-header {
    color: #333;
    font-size: 26px;
  }

  .woo-video-transition-inner {
    color: white;
    font-size: 45px;
    font-weight: bold;
  }
}
</style>
